<template>
  <HomeLayout sidebarClasss="sidebar-garden-help" :url_base="url_base" :logo="logo" :sidebar_items="admin_sidebar_items"
    :logout_default_icon="logout_default_icon" :logout_active_icon="logout_active_icon" />
</template>
    
    
<script>
import $ from "jquery";
import HomeLayout from "@/components/HomeLayout/Index.vue";
import { getImgUrl } from "@/utils/helper-functions.js";
export default {
  name: "GardenHelpContractorHome",
  components: { HomeLayout },
  data() {
    return {
      url_base: "garden_help",
      logo: this.getImgUrl("garden-help/Logo.png"),
      admin_sidebar_items: [
        {
          title: "My Jobs",
          url: "jobs/my_jobs",
          default_icon: this.getImgUrl("garden-help/my-jobs-icon.png"),
          active_icon: this.getImgUrl("garden-help/my-jobs-icon-active.png"),
        },
        // {
        //   title: "Add New Job",
        //   url: "jobs/add_job",
        //   default_icon: this.getImgUrl("garden-help/add-job-icon.png"),
        //   active_icon: this.getImgUrl("garden-help/add-job-icon-active.png"),
        // },
        {
          title: "My Profile",
          url: "my_profile",
          default_icon: this.getImgUrl("garden-help/my-profile-icon.png"),
          active_icon: this.getImgUrl("garden-help/my-profile-icon-active.png"),
        },
        {
          title: "Schedule",
          url: "jobs/schedule",
          default_icon: this.getImgUrl("garden-help/schedule-icon.png"),
          active_icon: this.getImgUrl("garden-help/schedule-icon-active.png"),
        },
      ],
      logout_default_icon: this.getImgUrl("garden-help/logout-icon.png"),
      logout_active_icon: this.getImgUrl("garden-help/logout-icon-active.png"),
    };
  },
  updated() { },
  mounted() {
    let user = JSON.parse(window.localStorage.getItem("user"));
    console.log("ccccccccccc", user.is_company, user.is_staff)
    if (user.is_company == 1) {
      this.admin_sidebar_items.push(
        {
          title: "Staff",
          url: "staff/list",
          default_icon: this.getImgUrl("garden-help/staff-icon.png"),
          active_icon: this.getImgUrl("garden-help/staff-icon-active.png"),
        },)

    }
    if ((user.is_staff === 0 && user.company_id == null) || (this.user.is_company == 1)) {
      this.admin_sidebar_items.splice(1, 0, {
        title: "Jobs Board",
        url: "jobs/jobs_board",
        default_icon: this.getImgUrl("garden-help/jobs-board-icon.png"),
        active_icon: this.getImgUrl("garden-help/jobs-board-icon-active.png"),
        disabled: true
      })
      this.admin_sidebar_items.splice(2, 0, {
        title: "Add New Job",
        url: "jobs/add_job",
        default_icon: this.getImgUrl("garden-help/add-job-icon.png"),
        active_icon: this.getImgUrl("garden-help/add-job-icon-active.png"),
      })

      // this.admin_sidebar_items.push(
      //   {
      //     title: "Staff",
      //     url: "staff/list",
      //     default_icon: this.getImgUrl("garden-help/staff-icon.png"),
      //     active_icon: this.getImgUrl("garden-help/staff-icon-active.png"),
      //   },)
    }
  },

  methods: {
    getImgUrl,
    logout() { },
  },
};
</script>
<style scoped::v-deep >
@import "styles/garden-help-button-styles.css";
@import "styles/garden-help-styles.css";
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/ContractorHome.vue